import { render, staticRenderFns } from "./accident-object.vue?vue&type=template&id=33fe4463"
import script from "./accident-object.vue?vue&type=script&lang=js"
export * from "./accident-object.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports